/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { FC } from 'react';
import styled, { css } from 'styled-components';
// import useMobileView from '@design-system/hooks/useMobileView';
// import useBreakPoint from '@design-system/hooks/useBreakPoint';
import Image, { ImageLoaderProps } from 'next/legacy/image';
// import { ArrowRightOutlined } from '@ant-design/icons';
import { getTrimedS3Url } from '@design-system/utils';
import useScreenSize from '@source/hooks/useScreenSize';
import { Breakpoint } from 'antd/lib/_util/responsiveObserve';
import { ArrowRightOutlined } from '@ant-design/icons';
import useGTMEvent from '@source/hooks/useGTMEvent';
import {
  ListingPromoCard,
  ListingPromoComponentType,
  ListingPromoDoubleCard,
  ListingPromoSingleCard,
} from '../BannersCarousel/types';

interface PromoBannerCardProps {
  region: string;
  language: string;
  promo: ListingPromoCard;
}

const StyledSingleCardWapper = styled.div`
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
  ${(props) => props.theme.typo.familyGoogle.regular};

  box-shadow: 0px 4px 15px ${(props) => props.theme.color.borderShadow};
  background: #fff;
`;
const StyledSingleCard = styled.div<{ isFullTile?: boolean }>`
  text-align: center;
  cursor: pointer;
  ${(props) =>
    props.isFullTile &&
    css`
      width: 100%;
      height: 100%;
    `}

  .content {
    height: 205px;
    text-align: left;
  }

  .card-cta {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 3px;

    .card-cta-label {
      line-height: 100%;
    }
    .card-cta-icon {
      font-size: 20px;
    }
  }
`;

const StyledDoubleCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  height: 100%;
  ${(props) => props.theme.typo.familyGoogle.regular};
  background: transparent;

  .sub-card {
    flex: 1;
    cursor: pointer;
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    position: relative;
    box-shadow: 0px 4px 15px ${(props) => props.theme.color.borderShadow};
  }
`;

const PromoBannerCard: FC<PromoBannerCardProps> = ({ promo }) => {
  const screenSize = useScreenSize();
  const { pushGTMEvent } = useGTMEvent();
  const { values } = promo;
  const componentType = values?.[0]?.__component;

  const loader = ({ src, width }: ImageLoaderProps) => {
    const trimmedPhotoUrl = getTrimedS3Url(src);
    return `${trimmedPhotoUrl}`;
  };

  const handleOnClickCTA = (ctaUrl?: string, isOpenUrlToNewTab?: boolean) => {
    pushGTMEvent({
      event: 'click_promo_tile',
    });
    if (isOpenUrlToNewTab && ctaUrl) {
      return window.open(encodeURI(ctaUrl));
    }
    if (ctaUrl) {
      window.location.href = encodeURI(ctaUrl);
    }
    return null;
  };

  const renderSingleCard = (data: ListingPromoCard) => {
    if (!data) return null;
    const { images, contents, cta, background_color } = data?.values?.[0] as ListingPromoSingleCard;
    const topImg = images[screenSize as Breakpoint].url;
    if (contents) {
      const bottomContent = contents[screenSize as Breakpoint];
      const { label, url, styles } = cta || {};

      return (
        <StyledSingleCardWapper style={{ backgroundColor: background_color }}>
          <StyledSingleCard onClick={() => handleOnClickCTA(images?.ctaUrl, images?.isOpenUrlToNewTab)}>
            <Image
              loader={loader}
              src={topImg}
              alt="listingPromoCard"
              width={500}
              height={281} // 16/9
              layout="responsive"
              sizes={`(max-width: 768px) 100vw,
                (max-width: 1280px) 50vw,
                382px`}
            />
            <div className="content" dangerouslySetInnerHTML={{ __html: bottomContent }} />
            {cta && (
              <div
                className="card-cta"
                style={styles}
                onClick={() => handleOnClickCTA(images?.ctaUrl, images?.isOpenUrlToNewTab)}
              >
                <span className="card-cta-label">{label}</span> <ArrowRightOutlined className="card-cta-icon" />
              </div>
            )}
          </StyledSingleCard>
        </StyledSingleCardWapper>
      );
    }

    return (
      <StyledSingleCardWapper>
        <StyledSingleCard onClick={() => handleOnClickCTA(images?.ctaUrl, images?.isOpenUrlToNewTab)} isFullTile>
          {/* <Image
            loader={loader}
            src={topImg}
            alt="listingPromoCard"
            width={384}
            height={462}
            layout="responsive"
            sizes={`(max-width: 768px) 100vw,
                (max-width: 1280px) 50vw,
                384px`}
          /> */}
          <img src={topImg} alt="listing-promo-full" width="100%" height="100%" />
        </StyledSingleCard>
      </StyledSingleCardWapper>
    );
  };

  const renderDoubleCard = (data: ListingPromoCard) => {
    const { top_images: topImages, bottom_images: bottomImages } = data?.values?.[0] as ListingPromoDoubleCard;
    const topImg = topImages[screenSize as Breakpoint].url;
    const bottomImg = bottomImages[screenSize as Breakpoint].url;

    return (
      <StyledDoubleCard>
        <div className="sub-card" onClick={() => handleOnClickCTA(topImages?.ctaUrl, topImages?.isOpenUrlToNewTab)}>
          <img src={topImg} alt="listing-promo-top" width="100%" height="100%" />
        </div>
        <div
          className="sub-card"
          onClick={() => handleOnClickCTA(bottomImages?.ctaUrl, bottomImages?.isOpenUrlToNewTab)}
        >
          <img src={bottomImg} alt="listing-promo-bottom" width="100%" height="100%" />
        </div>
      </StyledDoubleCard>
    );
  };

  const renderCard = () => {
    if (componentType === ListingPromoComponentType.Single) return renderSingleCard(promo);
    if (componentType === ListingPromoComponentType.Double) return renderDoubleCard(promo);
    return null;
  };

  return renderCard();
};

export default PromoBannerCard;
